// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width:650px){
    .notFoundImage{
        width: 16px;
        height: 16px;
    }
    .notFoundText{
        font-size: 10px;
    }
}

.mockup-link {
  color: #ff2d2d;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 500;
}`, "",{"version":3,"sources":["webpack://./src/components/NotFound.css"],"names":[],"mappings":"AAAA;IACI;QACI,WAAW;QACX,YAAY;IAChB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA;EACE,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["@media (max-width:650px){\n    .notFoundImage{\n        width: 16px;\n        height: 16px;\n    }\n    .notFoundText{\n        font-size: 10px;\n    }\n}\n\n.mockup-link {\n  color: #ff2d2d;\n  text-decoration: underline;\n  cursor: pointer;\n  font-weight: 500;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
